module.exports = __webpack_public_path__ + "img/error.a61aaca3.png";